module.exports = "<p>\r\n  workflows works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-general/workflows/workflows.component.html
// module id = 2404
// module chunks = 66